import { ref } from 'vue';
import axios from 'axios';

interface PostData {
    url: string;
    visibility: string;
    type: string;
    response_format: string;
    response_data: string;
    unauthorized_owner: string;
}

export function usePostApi() {
    const loading = ref(false);
    const error = ref<string | null>(null);
    const data = ref(null);

    const apiClient = axios.create({
        baseURL: '/',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });

    const sendPost = async (postData: PostData) => {
        loading.value = true;
        error.value = null;

        try {
            const response = await apiClient.post('https://comment.house/api/create', postData);
            // const response = await apiClient.post('/api/create', postData);
            data.value = response?.data;
            return response?.data;
        } catch {
            error.value = 'An error occurred';
        } finally {
            loading.value = false;
        }
    };

    return {
        loading,
        error,
        data,
        sendPost
    };
}
